"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const storeTourPathDB = (path) => __async(null, null, function* () {
  try {
    const res = yield fetch("/app_tours", {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({ app_tours: path })
    });
    if (!res.ok) {
      const errorData = yield res.json();
      throw new Error(errorData.message || `HTTP error! Status: ${res.status}`);
    }
    return yield res.json();
  } catch (error) {
    console.error("Error storing tour path:", error);
    return { status: "fail", error: error.message };
  }
});
const isTourPathCached = (urlPath) => {
  let existing = localStorage.getItem("visited_pages");
  existing = existing ? existing.split(",") : [];
  return existing.includes(urlPath);
};
const storePathToLocalStorage = (urlPath) => {
  let existing = localStorage.getItem("visited_pages");
  existing = existing ? existing.split(",") : [];
  if (!existing.includes(urlPath)) {
    existing.push(urlPath);
  }
  localStorage.setItem("visited_pages", existing.toString());
};
export { storeTourPathDB, storePathToLocalStorage, isTourPathCached };
